import { useCallback, useState } from 'react';
import { ApiError, requisitarArquivo, type Query } from '@/lib/api';
import { salvarBlob } from '@/lib/download';

export function mensagemExportacao(e: unknown): string {
  return e instanceof ApiError ? `${e.message}${e.code ? ` (${e.code})` : ''}` : 'falha de comunicação com a API';
}

/** Baixa um arquivo gerado no servidor (mesmos filtros da tela). Estado de carregando e erro com a mensagem e o `code` da API. */
export function useExportar() {
  const [exportando, setExportando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);
  const exportar = useCallback(async (caminho: string, query?: Query) => {
    setExportando(true);
    setErro(null);
    try {
      const { blob, nome } = await requisitarArquivo(caminho, query);
      salvarBlob(blob, nome);
    } catch (e) {
      setErro(mensagemExportacao(e));
    } finally {
      setExportando(false);
    }
  }, []);
  return { exportando, erro, exportar, limparErro: () => setErro(null) };
}
